import PropTypes from 'prop-types'
import React from 'react'

import Tab from './WordlistTab'
import WordlistEditor from './WordlistEditor'
import WordlistTable from './WordlistTable'

const Wordlist = ({
  mode,
  languages,
  availableLanguages,
  defaultLanguageId,
  entries,
  allEntries,
  totalEntries,
  searchQuery = '',
  myLists = [],
  selectedList,
  baseUrl,
  userIsLoggedIn,
  onSearchQueryInputChange,
  onShowLanguagePickerButtonClick,
  onLanguageCheckboxChange,
  onLoadMoreButtonClick,
  onEntrySpeakClick,
  onListTabClick,
  onCreateListTabClick,
  onEditorFormSubmit,
  onEditorFormCancel,
  onEditButtonClick,
  onDeleteButtonClick,
  onPrintButtonClick,
  onShareButtonClick,
  onCopyUrlButtonClick,
  showShareUrl = false,
  showLanguagePicker = false,
  loading = false,
  loaded = false,
  saving = false,
  duplicateList,
}) => {
  if (!loaded) {
    return (
      <div className="muted center py3">
        {loading ? 'Laddar…' : 'Kunde inte ladda skolorden'}
      </div>
    )
  }
  let tableProps = {
    languages,
    availableLanguages,
    defaultLanguageId,
    entries,
    totalEntries,
    searchQuery,
    onSearchQueryInputChange,
    onShowLanguagePickerButtonClick,
    onLanguageCheckboxChange,
    onLoadMoreButtonClick,
    onEntrySpeakClick,
    onEditButtonClick,
    onDeleteButtonClick,
    onPrintButtonClick,
    onShareButtonClick,
    onCopyUrlButtonClick,
    showEditButton:
      !!selectedList &&
      (myLists.find(list => list.id === selectedList) || {})
        .canEdit,
    showDeleteButton:
      !!selectedList &&
      (myLists.find(list => list.id === selectedList) || {})
        .canDelete,
    isSharedList:
      !!selectedList &&
      (myLists.find(list => list.id === selectedList) || {})
        .isSharedList,
    authorName:
      !!selectedList &&
      (myLists.find(list => list.id === selectedList) || {})
        .authorName,
    showPrintButton: mode === 'browse',
    showShareButton: mode === 'browse',
    showShareUrl,
    showLanguagePicker,
    userIsLoggedIn,
    duplicateList,
  }
  let editorProps = {
    mode,
    languages,
    availableLanguages,
    defaultLanguageId,
    entries,
    allEntries,
    totalEntries,
    searchQuery,
    myLists,
    selectedList,
    userIsLoggedIn,
    onSearchQueryInputChange,
    onShowLanguagePickerButtonClick,
    onLanguageCheckboxChange,
    onLoadMoreButtonClick,
    onEntrySpeakClick,
    onEditorFormSubmit,
    onEditorFormCancel,
    showShareUrl,
    showLanguagePicker,
    saving,
  }
  availableLanguages.sort(function(a, b) {
    if (a.label === null || b.label === null) {
      return 0
    }
    var labelA = a.label.toLowerCase()
    var labelB = b.label.toLowerCase()
    if (labelA == 'svenska') {
      return -1
    }
    if (labelB == 'svenska') {
      return 1
    }
    if (labelA < labelB) {
      return -1
    }
    if (labelA > labelB) {
      return 1
    }
    return 0
  })
  languages.sort(function(a, b) {
    if (a.label === null || b.label === null) {
      return 0
    }
    var labelA = a.label.toLowerCase()
    var labelB = b.label.toLowerCase()
    if (labelA == 'svenska') {
      return -1
    }
    if (labelB == 'svenska') {
      return 1
    }
    if (labelA < labelB) {
      return -1
    }
    if (labelA > labelB) {
      return 1
    }
    return 0
  })
  return (
    <div>
      <div className="mb-2">
        <div className="flex flex-wrap items-end mrn-half">
          <Tab
            active={mode !== 'create' && !selectedList}
            onClick={onListTabClick.bind(null, false)}
            href={baseUrl}
          >
            Alla skolord
          </Tab>
          {myLists.map(list => {
            return (
              <Tab
                key={list.id}
                active={
                  mode !== 'create' &&
                  selectedList === list.id
                }
                onClick={onListTabClick.bind(null, list.id)}
                href={`${baseUrl}/${list.id}`}
              >
                {list.name}
              </Tab>
            )
          })}
          <Tab
            active={mode === 'create'}
            onClick={onCreateListTabClick}
            href={baseUrl}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="inline h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg> Ny lista
          </Tab>
          <div className="border-b py-2 mb-2 flex-grow">
            &nbsp;
          </div>
        </div>
      </div>
      {mode === 'edit' || mode === 'create' ? (
        <WordlistEditor {...editorProps} />
      ) : (
        <WordlistTable {...tableProps} />
      )}
    </div>
  )
}

Wordlist.propTypes = {
  mode: PropTypes.string.isRequired,
  availableLanguages: PropTypes.array.isRequired,
  languages: PropTypes.array.isRequired,
  defaultLanguageId: PropTypes.string.isRequired,
  entries: PropTypes.array.isRequired,
  allEntries: PropTypes.array.isRequired,
  totalEntries: PropTypes.number.isRequired,
  searchQuery: PropTypes.string,
  myLists: PropTypes.array,
  selectedList: PropTypes.string,
  baseUrl: PropTypes.string,
  userIsLoggedIn: PropTypes.bool,
  onSearchQueryInputChange: PropTypes.func,
  onShowLanguagePickerButtonClick: PropTypes.func,
  onLanguageCheckboxChange: PropTypes.func,
  onLoadMoreButtonClick: PropTypes.func,
  onEntrySpeakClick: PropTypes.func,
  onListTabClick: PropTypes.func,
  onCreateListTabClick: PropTypes.func,
  onEditorFormSubmit: PropTypes.func,
  onEditorFormCancel: PropTypes.func,
  onEditButtonClick: PropTypes.func,
  onDeleteButtonClick: PropTypes.func,
  onPrintButtonClick: PropTypes.func,
  onShareButtonClick: PropTypes.func,
  onCopyUrlButtonClick: PropTypes.func,
  showShareUrl: PropTypes.bool,
  showLanguagePicker: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  saving: PropTypes.bool,
}

export default Wordlist
